import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';
import DocRowContainer from '../../cmn/DocRowContainer';
import FormAttachment from '../../../library/form/components/FormAttachment';

const DocAttachmentRow = (props) => {
    const { formObject, rowKey } = props;
    return (
        <li className="uiInline uiSpacerL5">
            <div>
            <DocRowContainer formObject={formObject} rowKey={rowKey} actionClass="uiActionBlock uiColumnCenter"
                containerClass="uiBoxAttachment uiContentCenter uiBorderRoundAll uiBoxSection200"
            >
                <div className="uiFileBlock">
                    <FormAttachment formObject={formObject} rowKey={rowKey} action={{ InputType: "a", paramName: "fileLink" }} />
                </div>
                <div style={{fontSize:'11px',height:'15px',overflow:'hidden'}} >
                    <FormROValue formObject={formObject} rowKey={rowKey} action={{ paramName: "desc" }} />
                </div>
            </DocRowContainer>
            </div>
        </li>
    )
}

export default DocAttachmentRow